import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from '@/shared/components/ui/dialog'

import { SalesForm } from './SalesForm'

export function AddSalesDialog({ open, onOpenChange, sales }) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="w-[calc(100vw-1.5rem)] max-w-2xl max-h-[90vh] overflow-y-auto rounded-2xl sm:rounded-3xl p-4 sm:p-6 shadow-2xl">
        <DialogHeader>
          <DialogTitle>
            {sales ? 'Edit Sales Person' : 'Add Sales Person'}
          </DialogTitle>
        </DialogHeader>

        <SalesForm
          key={sales?._id ?? 'new'}
          sales={sales}
          onCancel={() => onOpenChange(false)}
          onSuccess={() => onOpenChange(false)}
        />
      </DialogContent>
    </Dialog>
  )
}
